<template>
  <div class="columns">
    <div class="column is-offset-2 is-two-thirds">
      <p>
        This is a minimal example application using Shutter on the Goerli
        testnet. It is the first frontrunning resistant public on-chain
        billboard! For more information, check out
        <a
          href="https://shutter.ghost.io/p/711def71-d5f5-4786-9c46-525966aade56/"
          >this blog post</a
        >.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro",
};
</script>
